import { ComparisonKeys } from './../../model/comparisons';
import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-comparison-selector',
  templateUrl: './comparison-selector.component.html',
  styleUrls: ['./comparison-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComparisonSelectorComponent implements OnInit {

  private _ready = false;
  private _comparison: ComparisonKeys = ComparisonKeys.None;

  @Input()
  public set comparison(cmp: ComparisonKeys) {
    const old = this._comparison;
    if (old !== cmp) {
      this._comparison = cmp;

      if (!!this._ready) {
        this.cdr.detectChanges();
        this.comparisonChange.emit(this._comparison);
      }
    }
  }
  public get comparison(): ComparisonKeys {
    return this._comparison;
  }
  @Output()
  public comparisonChange = new EventEmitter<ComparisonKeys>();
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this._ready = true;
  }

}
